import React from 'react';
import Navigation from '../../components/Navigation/Navigation';
import BreadCrumb from '../../components/BreadCrumb/BreadCrumb';
import MerchantType from '../../components/MerchantType/MerchantType';
import Footer from '../../components/Footer/Footer';

const CategoriesPage = ({ index }) => {
    return (
        <div>
            <Navigation />
            <BreadCrumb />
            <MerchantType index={index}/>
            <Footer />
        </div>
    );
};

export default CategoriesPage;